import { defineProvider } from '@/hooks'
import { GoodsData } from './utils'
import { Ref } from '@vue/composition-api'

export const goodsProvider = defineProvider<Ref<GoodsData>>()
